
define('plugins/underscore/mixins',[],function() {
	
	_.mixin({
		
		parallel: function(arrayMethods, fn, context) {
			
			if(typeof arrayMethods == "function")
				arrayMethods = [arrayMethods];

			var num_callbacks = arrayMethods.length;

			// Array of blank items, we will be populating this soon
			var returns = _.map(arrayMethods, function() { return; });

			var c = _.after(num_callbacks, function() {

				// Lets apply the callback in the right context and the return content
				fn.apply((context ? context : this), returns);

			}); // fn, (context ? context : this))

			for(var i in arrayMethods) {

				(function(i) {
					arrayMethods[i](function(arg1) {

						// Lets hold onto the first bit of data returned.
						returns[i] = arg1;

						c();
					});
				})(i);
			}

		}
	});


});